<template>
    <div class="SalesTerms">
        <terms-and-consents
            :forId="'js-terms-sales'"
            :isChecked="false"
            :isRequired="true"
            :label="$t('sales_terms:approve_message')"
            :name="'cgv'"
            class="SalesTerms-terms"
            @terms-and-consents-approval-changed="updateSalesTermsAccepted"
        />
        <div class="SalesTerms-link">
            <a
                :href="sanitizeUrl(getLink)"
                class="d-flex align-center"
                target="_blank"
            >
                {{ $t('sales_terms:consult_message') }}
                <v-icon
                    :aria-label="$t('open_new_tab')"
                    class="pl-1"
                    color="primary"
                    size="medium"
                >
                    mdi-open-in-new
                </v-icon>
            </a>
        </div>
    </div>
</template>

<script setup>
import TermsAndConsents from '@/StoreWeb/components/checkout/TermsAndConsents'
import { sanitizeUrl } from '@braintree/sanitize-url'
import config from 'config'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const emit = defineEmits(['SalesTermsApprovalChanged'])

const { t } = useI18n()

const getLink = computed(() => {
    /* TODO : Sales terms link has to be managed differently as in store, it may have several ticketing providers,
    each one with different sales terms, so we will possibly have several links, depending on cart content.
    Moreover, depending on network, the link could be an internal or external link, so it will be either a <a>
    tag or a <router-link> tag */
    return t('sales_terms:link', {
        cmsUrl: config.cms_url
    })
})

function updateSalesTermsAccepted (isChecked) {
    emit('SalesTermsApprovalChanged', isChecked)
}
</script>

<style lang='scss' scoped>
@import 'globalScss';

.SalesTerms {
    &-terms {
        margin-bottom: $s1;
    }

    &-link {
        padding-left: 30px;
        cursor: pointer;
        font-size: $font-xsmall;
        color: $color-brandPrimary;
        transition: all .3s;

        &:hover,
        &:focus {
            color: $color-brandPrimaryDark;
        }
    }
}
</style>
